<template>
  <div class="list">
    <ul class="fix">
      <li v-if="hasDetail(point)" v-for="point in data">
        
        <router-link :to="{name:'KoukoDashiDetail', params:{id:point.id}}" append>
          <img class="object-fit-img" :src="point.thumbnail">
          <div class="ttlarea">
            <p>{{point.ruby}}</p>
            <p>{{point.title}}</p>
          </div>
        </router-link>
        
      </li>
    </ul>
  </div>
</template>

<style lang="less">
  //mediaquery設定
  @screen-xs-max: 660px; //スマホ
  @screen-sm-max: 768px; //ipad
  @screen-lg-max: 1200px; //ブラウザサイズ1200px以下
  .screen-xs(@rules) {
      @media (max-width: @screen-xs-max) { @rules(); } 
  }
  .screen-sm(@rules) {
      @media (max-width: @screen-sm-max) { @rules(); }
  }
  .screen-lg(@rules) {
      @media (max-width: @screen-lg-max) { @rules(); }
  }
  .list {
    margin: 30px 0 100px 0;
    ul {
      margin: 100px 0;
      padding: 0;
      list-style:none;
      .screen-xs({
          margin: 30px auto 100px;
        });
      li{
        width: 30%;
        height: 300px;
        display: inline-block;
        float: left;
        &:not(:nth-of-type(3n+1)){
          margin-left: 5%;
          .screen-xs({
            margin-left: 0;
          });
        }
        &:nth-of-type(n+4){
          margin-top: 100px;
          .screen-xs({
            margin-top: 0;
          });
        }
        .screen-sm({
          height: 210px;
        });
        .screen-xs({
          margin-bottom: 20px;
          width: 100%;
          height: auto;
        });
        img{
          width: 100%;
          height: 250px;
          display: inline-block;
          object-fit: cover;
          font-family: 'object-fit: cover;';
          vertical-align: middle;
          .screen-sm({
            height: 150px;
          });
          .screen-xs({
            padding-left: 5%;
            width: 35%;
            height: auto;
          });
        }
        a{
          text-decoration: none;
        }
        .ttlarea{
          .screen-xs({
            padding-left: 10%;
            width: 50%;
            display: inline-block;
            vertical-align: middle;
          });
          p{
            color: #000;
            text-align: left;
            &:first-child{
              padding-top: 10px;
              font-size: 10px;
            }
            &:last-child{
              font-size: 16px;
            }
          }
        }
      }
    }
  }
</style>

<script>
  export default {
    name: 'List',
    props: {
      data:Array
    },
    methods: {
      hasDetail(point) {
        if (point.text && (point.text.length > 0)) {
          return true
        }
        return false
      },
    }
  }
</script>